import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "The method of the image sources allows to calculate the acoustic field generated by a source in an open space limited by a single or several reflecting wall, as well as in a completely close space, i.e. in a cavity of any shape. Select an open or close 2D space type to display an example of a source and its associated image sources. Note that in some cases, the number of image sources is finite. Note also that in the case of cavities, the number of image sources is infinite, although in some specific case a periodic structure can be found. The amplitude weights of the sources depend on the reflection coefficient of the boundaries and on the number of reflections that lead to the source but are not shown here. From the sources cloud, the audibility test should then be done with the knowledge of the receiver (see Lesson 3.8 for more details).",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 6],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "1 wall",
                  scrollbars: false,
                  styles: {
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                    fontWeight: 800,
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/01/24/principle/1-wall.svg`,
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
